import React, { useState, useEffect } from 'react';
import dexscreenerIcon from '../assets/icons/dexscreener.png';
import birdeyeIcon from '../assets/icons/birdeye.png';
import jupiterIcon from '../assets/icons/jupiter.png';
import meteoraIcon from '../assets/icons/meteora.png';
import '../styles/modals.css';

interface TokenDialogProps {
  isDark: boolean;
  onClose: () => void;
}

const CloseIcon = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path d="M5 3H3v18h18V3H5zm14 2v14H5V5h14zm-8 4H9V7H7v2h2v2h2v2H9v2H7v2h2v-2h2v-2h2v2h2v2h2v-2h-2v-2h-2v-2h2V9h2V7h-2v2h-2v2h-2V9z" fill="currentColor"/>
  </svg>
);

export default function TokenDialog({ isDark, onClose }: TokenDialogProps) {
  const [copied, setCopied] = useState(false);
  const tokenMint = import.meta.env.VITE_SPL_TOKEN_MINT;

  // Prevent background scrolling when modal is open
  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  const handleCopyCA = () => {
    navigator.clipboard.writeText(tokenMint);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div className="modal-backdrop" onClick={onClose} />
      <dialog 
        className={`modal-base token-dialog fullscreen-mobile ${isDark ? 'is-dark' : ''}`} 
        open
      >
        <form method="dialog" onClick={e => e.stopPropagation()}>
          <div className="modal-header">
            <h2 className="modal-title">Get Tokens</h2>
            <button 
              type="button"
              className="modal-close-button"
              onClick={onClose}
              aria-label="Close modal"
            >
              <CloseIcon />
            </button>
          </div>

          <div className="dialog-buttons">
            <div className="copy-button-container">
              <button 
                className="nes-btn copy-ca-button" 
                onClick={handleCopyCA}
              >
                Copy Contract Address
              </button>
              {copied && (
                <span className={`copy-status ${isDark ? 'is-dark' : ''}`}>
                  Copied!
                </span>
              )}
            </div>
            <button 
              className="nes-btn dexscreener-button" 
              onClick={() => window.open(`https://dexscreener.com/solana/${tokenMint}`, '_blank')}
            >
              See on <img src={dexscreenerIcon} alt="" width="20" height="20" /> Dexscreener
            </button>
            <button 
              className="nes-btn birdeye-button" 
              onClick={() => window.open(`https://birdeye.so/token/${tokenMint}?chain=solana`, '_blank')}
            >
              See on <img src={birdeyeIcon} alt="" width="20" height="20" /> Birdeye
            </button>
            <button 
              className="nes-btn jupiter-button" 
              onClick={() => window.open(`https://jup.ag/swap/SOL-${tokenMint}`, '_blank')}
            >
              Buy on <img src={jupiterIcon} alt="" width="20" height="20" /> Jupiter
            </button>
            <button 
              className="nes-btn meteora-button" 
              onClick={() => window.open(`https://meteora.ag/pool/${tokenMint}`, '_blank')}
            >
              LP on <img src={meteoraIcon} alt="" width="20" height="20" /> Meteora
            </button>
          </div>
        </form>
      </dialog>
    </>
  );
} 